import React from 'react';
import config from '../config'; 
import './Home.css';
import zachImage from '../images/zach.jpg';

const Home = () => (
  <div className="about-us">
  {/* Company Overview */}
  <section className="company-overview">
    <p>
      Welcome to <strong>{config.companyName}</strong>. Founded in the Fox Valley of Wisconsin with a vision to simplify family meal planning, 
      we specialize in delivering high-quality web and mobile solutions to solve the needs of consumers and businesses nationwide. 
      Our mission is to combine technology, creativity, and passion to build tools that allow average people to make the most of their technology.
    </p>
  </section>

  {/* TODO: Nick should be designing this himself */}
  {/* Founders Section */}
  <section className="founders">
    <h2>Meet the Founders</h2>
    
    <div className="founder">
      <img src="/images/nick.jpg" alt="Founder 1" className="founder-image" />
      <div className="founder-info">
        <h3>Nick Kantelberg</h3>
        <h5>Web Developer</h5>
        <p>
        Nick is a front-end developer with over a decade of experience crafting intuitive and visually engaging web experiences. He specializes in React and modern web technologies, bringing designs to life with clean, maintainable code. At Kander, he leads front-end development, ensuring every interface is both beautiful and functional. Outside of work, Nick enjoys woodworking, applying the same attention to detail and craftsmanship to projects both digital and physical.
        </p>
      </div>
    </div>

    <div className="founder">
      <img src={zachImage} alt="Zachary Vander Velden in a white button up shirt" className="founder-image" />
      <div className="founder-info">
        <h3>Zachary Vander Velden</h3>
        <h5>Mobile & Backend Developer</h5>
        <p>
        Zach is a software developer from the Fox Valley with a passion for building tools that make technology accessible to everyone. With experience spanning mobile and web development, he specializes in Swift, .NET, and cloud technologies on AWS. He has a keen interest in AI integration, applying it to automate workflows and deliver personalized user experiences. At Kander, he leads backend and iOS development, crafting seamless experiences from database to device. When he's not coding, you'll find him hiking, playing frisbee golf, or experimenting with music production.
        </p>
      </div>
    </div>
  </section>
</div>
);

export default Home;